export default __webpack_public_path__ + "static/media/1159480e43a542669a50422aaed6327c1602892526243.1fbefda2.webp";